import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Menuleverancier',
      options: {
        [null]: 'Menuleverancier selecteren',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Ander FoodAmigos-restaurant',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (POS)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'Lieferando URL',
        placeholder: 'URL van het restaurant in Lieferando',
      },
      [MenuProvider.Wolt]: {
        label: 'Wolt URL',
        placeholder: 'URL van het restaurant in Wolt',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Deliveroo-link van het restaurant',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: 'Open uw restaurant op Deliveroo en kopieer de link uit de adresbalk.',
        error:
          'Voer de link naar de menupagina van een restaurant op Deliveroo in. Die ziet er zo uit: https://deliveroo.co.uk/menu/city/area/restaurant-name.',
      },
      [MenuProvider.UberEats]: {
        label: 'Uber Eats URL',
        placeholder: 'URL van het restaurant in Uber Eats',
      },
      [MenuProvider.GloriaFood]: {
        label: 'GloriaFood-link',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'Als u de GloriaFood-bestelpagina gebruikt:',
            description: 'Voer uw foodbooking.com-bestel-URL in.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'Als GloriaFood op uw eigen website is ingebed:',
            description: 'Voer de URL in van de pagina op uw website waar de bestelwidget verschijnt.',
            example: 'https://yourrestaurant.com/order',
          },
        },
        error: 'Voer een geldige link in die begint met https://.',
        back_office_error:
          'Dit is een link naar het GloriaFood back-office, niet de pagina waar uw klanten bestellen. Open de bestelpagina van uw restaurant en plak die link in plaats daarvan.',
        wrong_platform_error:
          'Dit lijkt geen GloriaFood-link te zijn. Als u de door GloriaFood gehoste bestelpagina gebruikt, voer dan uw foodbooking.com-bestel-URL in. Als GloriaFood op uw eigen website is ingebed, voer dan de URL in van de pagina waarop uw bestelwidget verschijnt.',
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'Thuisbezorgd-URL',
        placeholder: 'URL van het restaurant op Thuisbezorgd',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'Takeaway.com-URL',
        placeholder: 'URL van het restaurant op Takeaway.com',
      },
      [MenuProvider.PysznePl]: {
        label: 'Pyszne.pl-URL',
        placeholder: 'URL van het restaurant op Pyszne.pl',
      },
      [MenuProvider.BistroSk]: {
        label: 'Bistro.sk-URL',
        placeholder: 'URL van het restaurant op Bistro.sk',
      },
      [MenuProvider.JustEat]: {
        label: 'Just Eat-URL',
        placeholder: 'URL van het restaurant op Just Eat',
      },
      [MenuProvider.DoorDash]: {
        label: 'DoorDash-link van het restaurant',
        placeholder: 'https://www.doordash.com/store/…',
        help: 'Open uw restaurant op doordash.com en kopieer de link uit de adresbalk.',
        error: 'Voer de link naar een DoorDash-restaurantpagina in. Die begint met https://www.doordash.com/store/.',
        store_number_error:
          'Deze link bevat alleen het winkelnummer. Open uw restaurant op doordash.com en kopieer de link met de naam, bijvoorbeeld https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Restaurant om menu van te kopiëren',
        placeholder: 'Selecteer restaurant om menu van te kopiëren',
      },
    },
  },
};
